import {createSelector, MemoizedSelector} from '@ngrx/store';
import {getClientSlicesStore} from '@app/store/client-slices/client-slices-selectors';

export const getSignalRStoreState = createSelector(
  getClientSlicesStore,
  (clientStore) => clientStore.signalR
);

export const getSignalRStoreStatus = createSelector(
  getSignalRStoreState,
  (signalRData) => signalRData
);

export const selectSignalRStatus = ():
  MemoizedSelector<object, boolean> =>
  createSelector(
    getSignalRStoreState,
    () =>
      true
  );




